var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgScaleup = function SvgScaleup(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.0415 20H2.2915C1.9465 20 1.6665 19.72 1.6665 19.375V15.625C1.6665 15.28 1.9465 15 2.2915 15H6.0415C6.3865 15 6.6665 15.28 6.6665 15.625V19.375C6.6665 19.72 6.3865 20 6.0415 20Z",
    fill: "#F8F9FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7085 20.0001H8.9585C8.6135 20.0001 8.3335 19.7201 8.3335 19.3751V11.4585C8.3335 11.1135 8.6135 10.8335 8.9585 10.8335H12.7085C13.0535 10.8335 13.3335 11.1135 13.3335 11.4585V19.3751C13.3335 19.7201 13.0535 20.0001 12.7085 20.0001Z",
    fill: "#F8F9FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.375 19.9998H15.625C15.28 19.9998 15 19.7198 15 19.3748V7.2915C15 6.9465 15.28 6.6665 15.625 6.6665H19.375C19.72 6.6665 20 6.9465 20 7.2915V19.3748C20 19.7198 19.72 19.9998 19.375 19.9998Z",
    fill: "#F8F9FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3784 0.122426C12.2976 0.0424259 12.1784 -0.00340739 12.0759 -7.40602e-05C9.72009 0.0440926 6.97176 1.41909 5.22676 3.41659C3.33843 3.48409 1.76343 4.05326 0.780927 5.03576C0.674261 5.14243 0.633427 5.29826 0.674261 5.44326C0.715094 5.58826 0.830927 5.69993 0.978427 5.73576L2.75259 6.16076L2.74176 6.17243C2.59343 6.33659 2.60009 6.58909 2.75676 6.74576L5.75426 9.74326C5.83509 9.82493 5.94176 9.86493 6.04926 9.86493C6.14926 9.86493 6.24843 9.82993 6.32759 9.75826L6.33926 9.74743L6.76426 11.5216C6.79926 11.6683 6.91093 11.7849 7.05676 11.8258C7.09426 11.8366 7.13176 11.8416 7.17009 11.8416C7.27926 11.8416 7.38509 11.7991 7.46509 11.7199C8.44843 10.7366 9.01676 9.16159 9.08426 7.27326C11.0843 5.52243 12.4568 2.77743 12.5009 0.424093C12.5018 0.311593 12.4584 0.202426 12.3784 0.122426Z",
    fill: "#F8F9FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.43005 8.62239C0.870881 9.18155 0.155048 11.5041 0.0175478 11.964C-0.0266188 12.1107 0.0142145 12.2699 0.121715 12.3782C0.201715 12.4574 0.307548 12.4999 0.416715 12.4999C0.456715 12.4999 0.496715 12.494 0.536714 12.4824C0.996715 12.3449 3.31838 11.6299 3.87838 11.0699C4.55338 10.3949 4.55338 9.29739 3.87838 8.62156C3.20171 7.94656 2.10338 7.94739 1.43005 8.62239Z",
    fill: "#F8F9FD"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.15,
    cy: 3.15,
    r: 1.15,
    fill: "#2E538E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgScaleup, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/scaleup.e0e8bbba.svg";
export { ForwardRef as ReactComponent };